import { Moon } from "lucide-react";

export function ThemeToggle({ mobile }: { mobile?: boolean }) {
  return (
    <div
      aria-label="Dark theme"
      className={
        mobile
          ? "flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground"
          : "inline-flex items-center gap-1.5 rounded-md px-2 py-2 text-sm font-medium text-muted-foreground"
      }
    >
      <Moon className="h-4 w-4" />
      <span className={mobile ? "flex-1 text-left" : "hidden sm:inline"}>
        Dark
      </span>
    </div>
  );
}
